import { z } from 'zod'
import i18n from './i18n'

// Custom error map that uses i18n translations
export const zodErrorMap: z.ZodErrorMap = (issue, ctx) => {
  const t = i18n.t.bind(i18n)

  switch (issue.code) {
    case z.ZodIssueCode.invalid_type:
      if (issue.received === 'undefined') {
        return { message: t('validation.required', { ns: 'common' }) }
      }
      return { message: t('validation.invalidType', { ns: 'common' }) }

    case z.ZodIssueCode.too_small:
      if (issue.type === 'string') {
        return {
          message: t('validation.minLength', {
            ns: 'common',
            count: issue.minimum as number,
          }),
        }
      }
      if (issue.type === 'array') {
        return {
          message: t('validation.minLength', {
            ns: 'common',
            count: issue.minimum as number,
          }),
        }
      }
      return { message: ctx.defaultError }

    case z.ZodIssueCode.too_big:
      if (issue.type === 'string') {
        return {
          message: t('validation.maxLength', {
            ns: 'common',
            count: issue.maximum as number,
          }),
        }
      }
      return { message: ctx.defaultError }

    case z.ZodIssueCode.invalid_string:
      if (issue.validation === 'email') {
        return { message: t('validation.email', { ns: 'common' }) }
      }
      return { message: ctx.defaultError }

    case z.ZodIssueCode.custom:
      // Handle custom validations like password mismatch
      if (ctx.defaultError?.toLowerCase().includes('password')) {
        return { message: t('validation.passwordMismatch', { ns: 'common' }) }
      }
      return { message: ctx.defaultError }

    default:
      return { message: ctx.defaultError }
  }
}

// Set as global default
z.setErrorMap(zodErrorMap)

// Re-apply error map on language change to update translations
i18n.on('languageChanged', () => {
  z.setErrorMap(zodErrorMap)
})
